import React from 'react';
import { GOLD } from '../../constants/theme';
import Divider from './Divider';

interface Props { text: string; }

const SecLabel: React.FC<Props> = ({ text }) => (
  <div>
    <p style={{ letterSpacing:6, fontSize:10, color:GOLD, fontFamily:'Montserrat', fontWeight:500, textAlign:'center', textTransform:'uppercase' }}>{text}</p>
    <Divider />
  </div>
);

export default SecLabel;